
import { Link } from 'react-router-dom';
import './Playlist.css';
import './Blog.css';
import client from './utils/sanity/client.ts';
import { format } from "date-fns"
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function Blog() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [posts, setPosts] = useState([])

  useEffect(() => {
    client.fetch(`*[_type == "post"] {
          title,
          slug,
          body,
          publishedAt,
          mainImage {
            asset -> {
              _id,
              url
            },
            alt,
          }
        } | order(publishedAt desc)`).then((data) => setPosts(data)).catch(console.error)
  }, [])

  return <>
    <div className='blogs-container'>
      <Helmet>
        <title>News Page</title>
        <meta name="description" content="Aethel News. Where you find out the latest news happening with Aethel Music." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="News Page - Aethel Music" />
        <meta property="og:description" content="Aethel News. Where you find out the latest news happening with Aethel Music." />
        <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/blog" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="News Page - Aethel Music" />
        <meta name="twitter:description" content="Aethel News. Where you find out the latest news happening with Aethel Music." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
      </Helmet>
      <h1>News</h1>
      <section className='blog-section'>

        {posts.map((post) => (
          <Link to={`/blog/${post.slug.current}`} key={post.slug.current}>
            <article className='blog-article'>
              <div className='img-title-container'>
                <LazyLoadImage src={post.mainImage.asset.url} className='main-image' alt={post.title} effect="blur" />

                <h2>{post.title}</h2></div>
              <div className="blog-titles">

                <p className='blog-post'>{`${post.body[0].children[0].text.substring(0, 50)}...`}</p>
                <p className='date'>
                  Published: <span>{format(new Date(post.publishedAt), "dd MMMM yyyy")}</span>
                </p>
                <Link to={`/blog/${post.slug.current}`}><button>
                  Read More</button>
                </Link>
              </div>
            </article>
          </Link>
        ))}
      </section>
    </div>
  </>
}
